export { Lyric } from "./lyric";
